import { 
  JournalEntry,
  Property,
  TableType,
  TABLE_TYPES,
} from './parser/types';
import { ParseSheetConfig } from './parser/config';
import { DEFAULT_CONFIGS } from './parser/default_config';
import { FlexParser } from './parser/flex_parser';

export type RunParseResult = {
  property: Property;
  reportDate: Date;

  groupsPerTable: Map<TableType, Array<Array<JournalEntry>>>;
  sumPerTable: Map<TableType, number>;
};

export function runParse({
  fileData,
  property,
  reportDate,
}: {
  fileData: Uint8Array;
  property: Property;
  reportDate: Date;
}): RunParseResult {
  const groupsPerTable = new Map<TableType, Array<Array<JournalEntry>>>();
  const sumPerTable = new Map<TableType, number>();

  for (const t of TABLE_TYPES) {
    const tableConfig = DEFAULT_CONFIGS[property][t];
    const config: ParseSheetConfig = {
      sheetName: t,
      tables: [tableConfig],
    };

    const parser = new FlexParser(config, property, reportDate);
    const result = parser.parse(fileData);
    groupsPerTable.set(t, result.journalEntryGroups);
    sumPerTable.set(t, result.sums.get(t) ?? 0);
  }

  return {
    property,
    reportDate,
    groupsPerTable,
    sumPerTable,
  };
}
